var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPhotocopiesFilled = function SvgHtlPhotocopiesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.413 13.558a1.623 1.623 0 0 1-.411-1.15c0-.3.014-5.985 0-6.962a1.4 1.4 0 0 1 .412-1.093 1.43 1.43 0 0 1 1.008-.352h1.049a.5.5 0 0 1 0 1H3.408a.257.257 0 0 1-.039 0 .442.442 0 0 0-.275.087.5.5 0 0 0-.092.344c.015 1.009 0 6.75 0 6.994a.633.633 0 0 0 .14.448.607.607 0 0 0 .458.13c1.183-.031 4.8 0 4.955 0a.5.5 0 0 1 0 1c-.037 0-3.754-.031-4.92 0h-.06a1.522 1.522 0 0 1-1.162-.446ZM6.999 12a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-6Zm1-5.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5Zm0-2a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
  })));
};
export default SvgHtlPhotocopiesFilled;